// LOWEN harness -> free leash quantity sync (A + B landing pages).
//
// The buy box adds one free leash per harness, but only at the moment of "Add to Cart".
// If the shopper later changes a harness quantity in the cart (+ / -), or removes one harness
// line while another one remains, nothing updated the leash, so the two numbers drifted apart
// (e.g. 2 harnesses / 1 leash, or 1 harness / 2 free leashes).
//
// This script keeps the leash quantity equal to the total number of harnesses, using ONE
// /cart/update.js request so the drawer re-renders once. It never touches anything else:
//   - removal of the LAST harness line (harness + all gifts) is still handled by cart-gift-fix.js
//   - any other cart change passes straight through
;(() => {
  const prevFetch = window.fetch.bind(window);

  // Harness products that come with one free leash each: A landing + B landing
  const SYNC_HARNESS_PRODUCT_IDS = new Set([
    10480234496346, // A: lowen-no-pull-harness
    11002876690778  // B: no-pull-harness-b-test
  ]);

  // The free gift whose quantity must equal the number of harnesses (free-no-pull-dog-leash)
  const LEASH_GIFT_PRODUCT_IDS = new Set([
    10362135052634
  ]);

  const isCartChangeRequest = (input) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    return /\/cart\/change(?:\.js)?(?:\?|$)/.test(url);
  };

  const readJsonBody = (body) => {
    if (typeof body !== 'string') return null;
    try {
      return JSON.parse(body);
    } catch {
      return null;
    }
  };

  const toUpdateUrl = (input) => {
    const url = typeof input === 'string' ? input : input?.url || '/cart/change.js';
    return url.replace(/\/cart\/change(?:\.js)?/, '/cart/update.js');
  };

  window.fetch = async function lowenHarnessGiftSync(input, init = {}) {
    if (!isCartChangeRequest(input)) return prevFetch(input, init);

    const payload = readJsonBody(init.body);
    const quantity = Number(payload?.quantity);

    if (
      !payload ||
      !Number.isFinite(quantity) ||
      quantity < 0 ||
      payload.line === undefined ||
      payload.line === null
    ) {
      return prevFetch(input, init);
    }

    try {
      const cartResponse = await prevFetch('/cart.js', { credentials: 'same-origin' });
      const cart = await cartResponse.json();
      const target = cart.items?.[Number(payload.line) - 1];

      if (!target || !SYNC_HARNESS_PRODUCT_IDS.has(Number(target.product_id))) {
        return prevFetch(input, init);
      }

      const harnessLines = cart.items.filter((item) =>
        SYNC_HARNESS_PRODUCT_IDS.has(Number(item.product_id))
      );

      // Removing the only harness line: cart-gift-fix.js removes it together with all its gifts.
      if (quantity === 0 && harnessLines.length === 1) {
        return prevFetch(input, init);
      }

      const otherHarnessQty = harnessLines
        .filter((item) => item.key !== target.key)
        .reduce((sum, item) => sum + item.quantity, 0);
      const harnessTotal = otherHarnessQty + quantity;

      const leashLines = cart.items.filter((item) =>
        LEASH_GIFT_PRODUCT_IDS.has(Number(item.product_id))
      );

      // Only act on the normal case (exactly one leash line) that is actually out of sync.
      if (leashLines.length !== 1 || leashLines[0].quantity === harnessTotal) {
        return prevFetch(input, init);
      }

      const updates = {};
      updates[target.key] = quantity;
      updates[leashLines[0].key] = harnessTotal;

      const response = await prevFetch(toUpdateUrl(input), {
        ...init,
        method: 'POST',
        headers: {
          ...(init.headers || {}),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates,
          sections: payload.sections || ['cart-drawer', 'cart-icon-bubble'],
          sections_url: payload.sections_url || window.location.pathname
        })
      });

      if (response && response.ok) return response;
      return prevFetch(input, init);
    } catch (error) {
      console.error('[LOWEN] Harness/leash sync failed. Falling back to the plain cart change.', error);
      return prevFetch(input, init);
    }
  };

  console.info('[LOWEN] cart-harness-gift-sync.js loaded');
})();
